import React, { createContext, useContext } from "react";
import { createTheme } from '@mui/material/styles';
import { PRIMARY_COLOUR, SECONDARY_COLOUR } from './constants';

export const getAppTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: PRIMARY_COLOUR,
      },
      secondary: {
        main: SECONDARY_COLOUR,
      },
      ...(mode === "dark"
        ? {
          background: {
            default: "#121212",
            paper: "#1e1e1e",
          },
        }
        : {
          background: {
            default: "#fafafa",
            paper: "#fff",
          },
        }),
    },
    typography: {
      fontFamily: '"Lato", "Roboto", "Arial", sans-serif',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
        },
      },
    },
  });



type Mode = "light" | "dark";

interface ThemeContextProps {
  mode: Mode;
  setMode: (mode: Mode) => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(undefined);

export const useThemeMode = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeMode must be used within ThemeProvider");
  }
  return context;
};